import { orderNew, orderAttachment, resendOTPToCustomer } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getOrderOptions(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderNew.base}options/`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderNew.base}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderNew.base}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getSplitOrder(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${orderNew.base}${payload.id}/split_order_by_item/`,
          payload.data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getSplitWithNoItems(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${orderNew.base}${payload.id}/split_order_by_item/`,
          payload.data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderView(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderNew.base}${id}/view/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getSplitOrderObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderNew.base}${id}/get_split_order_with_out_item_details/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createOrderObject(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${orderNew.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  resendOTP(data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${orderNew.base}${data.id}/resend_otp/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateOrderObject(id, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${orderNew.base}${id}/`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateOrderObject(id, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${orderNew.base}${id}/`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderSheet(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderNew.base}download_orders_sheet/`, {
          params: params,
          responseType: "blob",
          headers: {
            Accept: "application/xlsx",
          },
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderItemSheet(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderNew.base}download_orders_items_sheet/`, {
          params: params,
          responseType: "blob",
          headers: {
            Accept: "application/xlsx",
          },
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderAttachmentPODDownload(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderAttachment.base}generate_e_pod/`, {
          params: params,
          headers: { "Content-type": "application/pdf" },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderWayBillPDFDownload(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${orderNew.base}${id}/generate_waybill_pdf/`, {
          headers: { "Content-type": "application/pdf" },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  rescheduleOrder(data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${orderNew.base}reschedule_orders/`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  cancelOrder(data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${orderNew.base}cancelled_orders/`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  integrationSalesDeliveryOrderUpdate(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${orderNew.base}integration_delivery_sales_order_update/`,
          payload
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  integrationSalesPickupOrderUpdate(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${orderNew.base}integration_pickup_sales_order_update/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
